/* eslint-disable max-len */
import React from 'react';

import Icon from 'editor/src/component/Icon/index';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

function IconCopy({ className }: Props) {
  return (
    <Icon className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ strokeWidth: 0 }}
      >
        <path
          d="M6.14279 11.1478C5.6741 11.1478 5.27288 10.981 4.93912 10.6472C4.60536 10.3134 4.43848 9.91221 4.43848 9.44353V6.0349C4.43848 5.56621 4.60536 5.16499 4.93912 4.83123C5.27288 4.49746 5.6741 4.33058 6.14279 4.33058H9.55142C10.0201 4.33058 10.4213 4.49746 10.7551 4.83123C11.0889 5.16499 11.2557 5.56621 11.2557 6.0349V9.44353C11.2557 9.91221 11.0889 10.3134 10.7551 10.6472C10.4213 10.981 10.0201 11.1478 9.55142 11.1478H6.14279ZM6.14279 19.6694C5.6741 19.6694 5.27288 19.5025 4.93912 19.1688C4.60536 18.835 4.43848 18.4338 4.43848 17.9651V14.5565C4.43848 14.0878 4.60536 13.6866 4.93912 13.3528C5.27288 13.019 5.6741 12.8522 6.14279 12.8522H9.55142C10.0201 12.8522 10.4213 13.019 10.7551 13.3528C11.0889 13.6866 11.2557 14.0878 11.2557 14.5565V17.9651C11.2557 18.4338 11.0889 18.835 10.7551 19.1688C10.4213 19.5025 10.0201 19.6694 9.55142 19.6694H6.14279ZM14.6644 11.1478C14.1957 11.1478 13.7945 10.981 13.4607 10.6472C13.1269 10.3134 12.9601 9.91221 12.9601 9.44353V6.0349C12.9601 5.56621 13.1269 5.16499 13.4607 4.83123C13.7945 4.49746 14.1957 4.33058 14.6644 4.33058H18.073C18.5417 4.33058 18.9429 4.49746 19.2767 4.83123C19.6104 5.16499 19.7773 5.56621 19.7773 6.0349V9.44353C19.7773 9.91221 19.6104 10.3134 19.2767 10.6472C18.9429 10.981 18.5417 11.1478 18.073 11.1478H14.6644ZM14.6644 19.6694C14.1957 19.6694 13.7945 19.5025 13.4607 19.1688C13.1269 18.835 12.9601 18.4338 12.9601 17.9651V14.5565C12.9601 14.0878 13.1269 13.6866 13.4607 13.3528C13.7945 13.019 14.1957 12.8522 14.6644 12.8522H18.073C18.5417 12.8522 18.9429 13.019 19.2767 13.3528C19.6104 13.6866 19.7773 14.0878 19.7773 14.5565V17.9651C19.7773 18.4338 19.6104 18.835 19.2767 19.1688C18.9429 19.5025 18.5417 19.6694 18.073 19.6694H14.6644ZM6.14279 9.44353H9.55142V6.0349H6.14279V9.44353ZM14.6644 9.44353H18.073V6.0349H14.6644V9.44353ZM14.6644 17.9651H18.073V14.5565H14.6644V17.9651ZM6.14279 17.9651H9.55142V14.5565H6.14279V17.9651Z"
          fill="#212121"
        />
      </svg>
    </Icon>
  );
}

export default IconCopy;
